import * as photoTemplate from '../photoTemplate.js';
import occoEvent from '../eventManager.js';
import getQueryProvider from '../getQueryProvider-module.js';

getQueryProvider.init();
const { ALBUM_TYPES, KIOSK_MODE } = getQueryProvider;

function elId(id) {
  return document.getElementById(id);
}

export function initWatermarkTab() {
  elId('addPhotoWatermarkFromEdit').onclick = function () {
    photoTemplate.openTemplatePage();
  };
  elId('editPhotoWatermarkFromEdit').onclick = function () {
    photoTemplate.editTemplate(elId('occoWatermarkTemplatesSelect').value);
  };
  elId('refreshPhotoWatermarkFromEdit').onclick = function () {
    occoEvent.getWatermarkTemplateList(2, occoEvent.drawWatermarkTemplatesList);
  };
}

/**
 * Activating printer fields in the Edit Event modal
 *
 * @param  {Number} activePrinter
 */
export function editEventActivatePrinter(activePrinter) {
  const printFromAllAlbums = +occoEvent.getSelectedEventParam('printFromAllAlbums');
  const objCopiesCount = elId('max_print_copies_count') || {};
  const objPhotosCount = elId('max_print_photos_count') || {};
  const objPrintEveryPhoto = elId('printEveryPhoto') || {};
  const objPrintFromAllAlbumsCheck = elId('printFromAllAlbumsCheck') || {};
  const $objPrintImageList = $('#printImageList');
  let printerPoolsArray = [];
  if (occoEvent.getSelectedEventParam('printerPoolList')) {
    printerPoolsArray = occoEvent.getSelectedEventParam('printerPoolList').split(',');
  }
  if (activePrinter === 1) {
    $objPrintImageList.css('display', 'block');
    objCopiesCount.disabled = false;
    objPhotosCount.disabled = false;
    objPrintEveryPhoto.disabled = false;
    objPrintFromAllAlbumsCheck.disabled = false;

    if (
      (!KIOSK_MODE && !(ALBUM_TYPES.isOccoOwnerAlbum || ALBUM_TYPES.isEventOwnerAlbum) && printFromAllAlbums === 1) ||
      (!(ALBUM_TYPES.isOccoOwnerAlbum || ALBUM_TYPES.isEventOwnerAlbum) && printerPoolsArray.length > 1)
    ) {
      // $objPrintImageList.addClass("disable-print");
      $objPrintImageList.css('display', 'none');
    } else {
      $objPrintImageList.removeClass('disable-print');
    }
  } else {
    $objPrintImageList.css('display', 'none');
    objCopiesCount.disabled = true;
    objPhotosCount.disabled = true;
    objPrintEveryPhoto.checked = false;
    objPrintEveryPhoto.disabled = true;
    objPrintFromAllAlbumsCheck.disabled = true;
  }
}

window.editEventActivatePrinter = editEventActivatePrinter;

export function showHideKioskStreamOptionLink() {
  const collectLeads = occoEvent.getSelectedEventParam('collectLeads');
  elId('kiosk_stream_opt').disabled = collectLeads === '0';
}
